export default "__VITE_ASSET__DRye4CXr__"